import { HelpInfoModal } from '@/components/HelpInfoModal';
import styles from './KioskFooter.module.css';
import { useState } from 'react';
import { Button, Icon, Typography } from '@globalmed/atlas-ui';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { useKioskStore } from '@/stores/kiosk';

type TProps = {
  text?: string;
  variant?: 'fixed' | 'absolute';
};

/**
 * Renders the footer section used on kiosk pages.
 * Displays a help button that opens the HelpInfoModal,
 * optional informational text, and a kiosk device indicator.
 * @param props - Component props.
 * @param props.text - Optional text displayed in the center of the footer.
 * @param props.variant - Positioning variant of the footer.
 * @returns KioskFooter component.
 */
export const KioskFooter = ({ text, variant = 'fixed' }: TProps) => {
  const { t } = useTranslation();
  const [helpInfoModalOpen, setHelpInfoModalOpen] = useState(false);

  const kioskData = useKioskStore((state) => state.kioskData);

  return (
    <footer className={cn(styles.container, styles[variant])}>
      <HelpInfoModal
        open={helpInfoModalOpen}
        onOpenChange={() => setHelpInfoModalOpen((pr) => !pr)}
      />
      <Button
        text={t('need-help')}
        onClick={() => setHelpInfoModalOpen(true)}
        variant="secondary"
      />

      {text && (
        <Typography
          fontSize="12px"
          color={'var(--colors-gray500)'}
          sx={{ lineHeight: '18px' }}
        >
          {text}
        </Typography>
      )}

      <div className={styles.kioskBlock}>
        <Icon name="DisplayMonitor" size="16px" decorative />
        <Typography>{kioskData?.name}</Typography>
      </div>
    </footer>
  );
};
